import { IAgendaItem } from '@/shared/api-client/models/agenda/agenda-item';
import { IFileArchiveFile } from '@/shared/api-client/models/file-archive-file';
import { IHierarchyNode } from '@/shared/api-client/models/hierarchy-node';
import { ConsoleFacade } from '@/shared/helpers';
import { ArgumentValidator } from '@/shared/helpers/argument-validator';
import { Urls } from '@/shared/helpers/urls';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: { }
})
export default class AgendaHierarchyItemComponent extends Vue {

    @Prop() public node!: IHierarchyNode<IAgendaItem>;

    @Prop({default: null}) public activeAgendaItemId!: string;

    @Prop({default: []}) public handledAgendaItemIds!: string[];

    public get hasActiveItem(): boolean {

        return !!this.activeAgendaItemId;
    }

    public get isActive(): boolean {

        return this.node.entity.id.toLowerCase() === (this.activeAgendaItemId ? this.activeAgendaItemId.toLowerCase() : null);
    }

    public get isPreviousAgendaItem(): boolean {

        if (this.isActive) {
            return false;
        }

        return this.handledAgendaItemIds.find(x => x.toLowerCase() === this.node.entity.id.toLowerCase()) !== undefined;
    }

    public downloadUrl(file: IFileArchiveFile): string {

        ArgumentValidator.notNullOrEmpty(file, `file`);

        const fileSrc = Urls.fileArchiveDownloadFile(file.id);

        ConsoleFacade.log(`Downloading file`, fileSrc);

        return fileSrc;
    }
}